/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Tabs, Form, Input, Row, Col, Spin, Button, Modal,
  Card,
} from 'antd';
import { getCandidato } from 'api/catalogos/Candidatos';
import { getEstadosCiviles } from 'api/usuarios';
import Select from 'components/Select';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import {
  getEntrevistaInformePruebas,
  getEntrevistasInformePruebas,
  postEntrevistaInformePruebas,
  patchEntrevistaInformePruebas,
  deleteEntrevistaInformePruebas,
} from 'api/EntrevistasInformePruebas';
import {
  deleteEntrevistaInformePruebasPsicometrico,
  getEntrevistaInformePruebasPsicometrico,
  getEntrevistaInformePruebasPsicometricos,
  patchEntrevistaInformePruebasPsicometrico,
  postEntrevistaInformePruebasPsicometrico,
}
  from 'api/EntrevistasInformePruebaspsicometricas';
import { getResultados, patchEntrevistaInforme } from 'api/EntrevistasInforme';

const { TabPane } = Tabs;

export const informePsicometricoPruebasPermission = {
  permissionModel: 'informepsicometricopruebas',
  catalogsModels: [],
  tabsModels: [],
};

const ModalInforme = ({ selectedData, permission }) => {
  const [candidato, setCandidato] = useState(null);
  const [loading, setLoading] = useState(false);
  const [estadoCivilCatalogo, setEstadoCivilCatalogo] = useState([]);
  const [pruebas, setPruebas] = useState([]);
  const [pruebasPsicometrico, setPruebasPsicometrico] = useState([]);
  const [resultados, setResultados] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedPrueba, setSelectedPrueba] = useState(null);
  const [openPruebaModal, setOpenPruebaModal] = useState(false);
  const [pruebaForm] = Form.useForm();
  const [selectedRowKeysPsico, setSelectedRowKeysPsico] = useState([]);
  const [selectedPsico, setSelectedPsico] = useState(null);
  const [openPsicoModal, setOpenPsicoModal] = useState(false);
  const [psicoForm] = Form.useForm();
  const [resultadoForm] = Form.useForm();

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      if (!selectedData?.id) return;
      setLoading(true);

      try {
        const [
          dataCandidato,
          estadosCivil,
          pruebasInforme,
          pruebasInformePsicometrico,
          resultadosCatalogo,
        ] = await Promise.all([
          getCandidato(selectedData.candidato),
          getEstadosCiviles(),
          getEntrevistasInformePruebas({ informe_psicometrico: selectedData.id }),
          getEntrevistaInformePruebasPsicometricos({ informe_psicometrico: selectedData.id }),
          getResultados(),
        ]);

        if (mounted) {
          setEstadoCivilCatalogo(estadosCivil);
          setPruebas(pruebasInforme);
          setPruebasPsicometrico(pruebasInformePsicometrico);
          setResultados(resultadosCatalogo);

          // --- normalización del candidato
          const estadoCivilDesc = typeof dataCandidato.estado_civil === 'object'
            ? dataCandidato.estado_civil.descripcion
            : estadosCivil.find((e) => e.id === dataCandidato.estado_civil)?.descripcion || 'N/A';

          const nivelEstudiosDesc = dataCandidato?.nivel_de_estudios?.nombre || 'N/A';
          // eslint-disable-next-line max-len
          const plazaSolicitadaDesc = dataCandidato?.solicitud_de_contratacion?.directorio_de_area_adscripcion_plaza
            ?.clave_y_nombre || 'N/A';
          // eslint-disable-next-line max-len
          const puestoSolicitadoDesc = dataCandidato?.solicitud_de_contratacion?.puesto_plaza?.clave_y_descripcion
          || dataCandidato?.puesto_plaza?.descripcion
          || 'N/A';

          setCandidato({
            ...dataCandidato,
            estado_civil_desc: estadoCivilDesc,
            nivel_estudios_desc: nivelEstudiosDesc,
            plaza_solicitada_desc: plazaSolicitadaDesc,
            puesto_solicitado_desc: puestoSolicitadoDesc,
          });

          // --- inicializar formulario de resultado
          resultadoForm.setFieldsValue({
            conclusion: selectedData?.conclusion,
            examen_tecnico: selectedData?.examen_tecnico,
            conclusion_final: selectedData?.conclusion_final,
            resultado_general: selectedData?.resultado_general,
            comentarios_del_resultado_general: selectedData?.comentarios_del_resultado_general,
            recomendaciones: selectedData?.recomendaciones,
          });
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('[Modal Informe] error al cargar datos del candidato', err);
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchData();

    return () => {
      mounted = false;
    };
  }, [selectedData, resultadoForm]);

  const columnsPruebas = [
    {
      titleText: 'Descripción',
      dataIndex: 'descripcion',
      key: 'descripcion',
      width: 250,
    },
    {
      titleText: 'Conclusión',
      dataIndex: 'conclusion',
      key: 'conclusion',
      width: 400,
    },
    {
      titleText: 'Observaciones',
      dataIndex: 'observaciones',
      key: 'observaciones',
      width: 300,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 150,
      render: (val) => (val === 1 ? 'Activo' : 'Inactivo'),
    },
  ];

  const columnsPsicometrico = [
    {
      titleText: 'Descripción',
      dataIndex: 'descripcion',
      key: 'descripcion',
      width: 250,
    },
    {
      titleText: 'Calificación',
      dataIndex: 'calificacion',
      key: 'calificacion',
      width: 150,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 150,
      render: (val) => (val === 1 ? 'Activo' : 'Inactivo'),
    },
  ];

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedPrueba(record);
  };

  const handleAdd = () => {
    setSelectedPrueba(null);
    pruebaForm.resetFields();
    setOpenPruebaModal(true);
  };

  const handleEdit = async () => {
    if (!selectedPrueba) return;
    const fullPrueba = await getEntrevistaInformePruebas(selectedPrueba.id);
    pruebaForm.setFieldsValue(fullPrueba);
    setOpenPruebaModal(true);
  };

  const handleDelete = () => {
    if (!selectedPrueba) return;
    Modal.confirm({
      title: '¿Eliminar prueba?',
      content: `Se eliminará la prueba: ${selectedPrueba.descripcion}`,
      okText: 'Sí',
      cancelText: 'No',
      async onOk() {
        const deleted = await deleteEntrevistaInformePruebas(selectedPrueba.id);
        if (deleted) {
          setSelectedPrueba(null);
          setSelectedRowKeys([]);
          // eslint-disable-next-line max-len
          const refreshed = await getEntrevistasInformePruebas({ informe_psicometrico: selectedData.id });
          setPruebas(refreshed);
        }
      },
    });
  };

  const onFinishPrueba = async (values) => {
    const payload = {
      ...values,
      informe_psicometrico: selectedData.id,
    };

    let saved;
    if (selectedPrueba) {
      saved = await patchEntrevistaInformePruebas(selectedPrueba.id, payload);
    } else {
      saved = await postEntrevistaInformePruebas(payload);
    }

    if (saved) {
      setOpenPruebaModal(false);
      // eslint-disable-next-line max-len
      const refreshed = await getEntrevistasInformePruebas({ informe_psicometrico: selectedData.id });
      setPruebas(refreshed);
      setSelectedRowKeys([saved.id]);
      setSelectedPrueba(saved);
    }
  };

  const handleOnRowClickPsico = (record) => {
    setSelectedRowKeysPsico([record.id]);
    setSelectedPsico(record);
  };

  const handleAddPsico = () => {
    setSelectedPsico(null);
    psicoForm.resetFields();
    setOpenPsicoModal(true);
  };

  const handleEditPsico = async () => {
    if (!selectedPsico) return;
    const full = await getEntrevistaInformePruebasPsicometrico(selectedPsico.id);
    psicoForm.setFieldsValue(full);
    setOpenPsicoModal(true);
  };

  const handleDeletePsico = () => {
    if (!selectedPsico) return;
    Modal.confirm({
      title: '¿Eliminar prueba psicométrica?',
      content: `Se eliminará: ${selectedPsico.descripcion}`,
      okText: 'Sí',
      cancelText: 'No',
      async onOk() {
        const deleted = await deleteEntrevistaInformePruebasPsicometrico(selectedPsico.id);
        if (deleted) {
          setSelectedPsico(null);
          setSelectedRowKeysPsico([]);
          const refreshed = await getEntrevistaInformePruebasPsicometricos({
            informe_psicometrico: selectedData.id,
          });
          setPruebasPsicometrico(refreshed);
        }
      },
    });
  };

  const onFinishPsico = async (values) => {
    const payload = {
      ...values,
      informe_psicometrico: selectedData.id,
    };

    let saved;
    if (selectedPsico) {
      saved = await patchEntrevistaInformePruebasPsicometrico(selectedPsico.id, payload);
    } else {
      saved = await postEntrevistaInformePruebasPsicometrico(payload);
    }

    if (saved) {
      setOpenPsicoModal(false);
      const refreshed = await getEntrevistaInformePruebasPsicometricos({
        informe_psicometrico: selectedData.id,
      });
      setPruebasPsicometrico(refreshed);
      setSelectedRowKeysPsico([saved.id]);
      setSelectedPsico(saved);
    }
  };

  const onFinishResultado = async (values) => {
    try {
      setLoading(true);
      await patchEntrevistaInforme(selectedData.id, values);
    // puedes recargar o refrescar el padre si es necesario
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('[Modal Informe] error al guardar el resultado', err);
    } finally {
      setLoading(false);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  return (
    <Spin spinning={loading} tip="Cargando candidato...">
      <Tabs defaultActiveKey="1" type="card">
        {/* TAB GENERALES */}
        <TabPane tab="Generales" key="1">
          <Form layout="vertical">
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Nombre">
                  <Input value={candidato?.numero_y_nombre_completo} disabled />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Fecha de Nacimiento">
                  <Input
                    value={candidato?.fecha_de_nacimiento || 'N/A'}
                    disabled
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Nivel de Estudios">
                  <Input value={candidato?.nivel_estudios_desc} disabled />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Estado Civil">
                  <Input
                    value={
                      candidato?.estado_civil?.descripcion
                      // eslint-disable-next-line max-len
                      || estadoCivilCatalogo.find((e) => e.id === candidato?.estado_civil)?.descripcion
                      || candidato?.estado_civil_desc
                      || 'N/A'
                    }
                    disabled
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Área Solicitada">
                  <Input value={candidato?.plaza_solicitada_desc} disabled />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Puesto Solicitado">
                  <Input value={candidato?.puesto_solicitado_desc} disabled />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </TabPane>

        <TabPane tab="Pruebas" key="2">
          <Table
            cols={columnsPruebas}
            data={pruebas.results || []}
            pagination={false}
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd: handleAdd,
              onClickEdit: handleEdit,
              onClickDelete: handleDelete,
            }}
            permission={{
              hasAllViewPermission: true,
              add: true,
              change: true,
              delete: true,
            }}
            // permission={permission}
          />
        </TabPane>

        {/* TAB PSICOMÉTRICO */}
        <TabPane tab="Psicométrico" key="3">
          <Table
            cols={columnsPsicometrico}
            data={pruebasPsicometrico.results || []}
            pagination={false}
            rowSelection={{
              selectedRowKeys: selectedRowKeysPsico,
              type: 'radio',
            }}
            handleOnRowClick={handleOnRowClickPsico}
            controls={{
              onClickAdd: handleAddPsico,
              onClickEdit: handleEditPsico,
              onClickDelete: handleDeletePsico,
            }}
            permission={{
              hasAllViewPermission: true,
              add: true,
              change: true,
              delete: true,
            }}
          />
        </TabPane>
        {/* TAB RESULTADO */}
        <TabPane tab="Resultado" key="4">
          <Card
            className="mt-4"
            size="small"
            title={(
              <FormSubmitControls
                label="Resultado del Informe"
                onFinish={() => resultadoForm.submit()}
                loading={loading}
                allowSave
              />
    )}
          >
            <Form
              layout="vertical"
              form={resultadoForm}
              onFinish={onFinishResultado}
            >
              <Row gutter={16}>
                {/* <Col span={12}>
                <Form.Item name="conclusion" label="Conclusión">
                  <Input.TextArea rows={2} />
                </Form.Item>
              </Col> */}
                <Col span={12}>
                  <Form.Item name="examen_tecnico" label="Examen Técnico">
                    <Input.TextArea rows={2} />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item name="conclusion_final" label="Conclusión Final">
                    <Input.TextArea rows={2} />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    name="comentarios_del_resultado_general"
                    label="Comentarios del Resultado General"
                  >
                    <Input.TextArea rows={3} />
                  </Form.Item>
                </Col>

              </Row>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    name="recomendaciones"
                    label="Recomendaciones"
                  >
                    <Input.TextArea rows={2} />

                  </Form.Item>
                </Col>
              </Row>

              <Row>

                <Col span={24}>
                  <Form.Item name="resultado_general" label="Resultado General">
                    <Select
                      labelProp="descripcion"
                      keyProp="id"
                      dataSource={resultados}
                    />
                  </Form.Item>
                </Col>

              </Row>

            </Form>
          </Card>
        </TabPane>

      </Tabs>
      <Modal
        open={openPruebaModal}
        onCancel={() => setOpenPruebaModal(false)}
        footer={null}
        destroyOnClose
        title={(
          <FormSubmitControls
            label={selectedPrueba ? 'Editar Prueba' : 'Agregar Prueba'}
            onFinish={() => pruebaForm.submit()} // dispara el submit del form
            onCancel={() => setOpenPruebaModal(false)}
            // loading={loadingPrueba}
            allowSave
          />
  )}
      >
        <Form
          layout="vertical"
          form={pruebaForm}
          onFinish={onFinishPrueba}
          initialValues={{ estados_globales: 1 }}
          scrollToFirstError
          name="pruebaForm"
        >
          <Form.Item
            name="descripcion"
            label="Descripción"
            rules={[{ required: true, message: 'Campo requerido' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="conclusion"
            label="Conclusión"
            rules={[{ required: true, message: 'Campo requerido' }]}
          >
            <Input.TextArea autoSize />
          </Form.Item>

          <Form.Item name="observaciones" label="Observaciones">
            <Input.TextArea autoSize />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        open={openPsicoModal}
        onCancel={() => setOpenPsicoModal(false)}
        footer={null}
        destroyOnClose
        title={(
          <FormSubmitControls
            label={selectedPsico ? 'Editar Psicométrico' : 'Agregar Psicométrico'}
            onFinish={() => psicoForm.submit()}
            onCancel={() => setOpenPsicoModal(false)}
            // loading={loadingPsico}
            allowSave
          />
  )}
      >
        <Form
          layout="vertical"
          form={psicoForm}
          onFinish={onFinishPsico}
          initialValues={{ estados_globales: 1 }}
          scrollToFirstError
          name="psicoForm"
        >
          <Form.Item
            name="descripcion"
            label="Descripción"
            rules={[{ required: true, message: 'Campo requerido' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="calificacion"
            label="Calificación"
            rules={[{ required: true, message: 'Campo requerido' }]}
          >
            <Input maxLength={250} style={{ width: '100%' }} />
          </Form.Item>
        </Form>
      </Modal>

    </Spin>
  );
};

export default ModalInforme;
